module.exports = __webpack_public_path__ + "static/media/globe-stand.922bfd3d.svg";